import React from 'react'
import { useTranslation } from '@sailor/i18n-web'
import {
  FooterLogo,
} from './styles'
import logoWhite from '@/assets/images/logoWhite-11a297.png'
import Container from '../Container'
import styles from './index.module.less'
import { Link } from 'react-router-dom'
import { QRCodeCanvas } from 'qrcode.react'
import { DOWNLOAD_LINK } from '@/common/utils/consts'

const Footer = () => {
  const { t } = useTranslation()

  return (
    <Container style={{ padding: '6rem 0' }}>
      <div className={styles.footerContent}>
        <div>
          <FooterLogo src={logoWhite} alt="Keeta" />
          <div  className={styles.linkWraper}>
            <div className={styles.contactItem}><Link to="/information"> {t('ent_o_nav_information', '资讯中心')}</Link></div>
            <div className={styles.contactItem}><Link to="/question"> {t('ent_o_nav_faq', '常见问题')}</Link></div>
            <div className={`${styles.contactItem} ${styles.contactItemLastA}`}><Link to="/contact"> {t('ent_o_nav_contact', '联系我们')}</Link></div>
            <div className={`${styles.contactItem} ${styles.contactItemPc}`}
              style={{ textDecoration: 'none' }}> {t('ent_o_footer_contact_corporate', 'Corporate Services')}: corporate.hk@keetainc.com </div>
          </div>
          <div className={styles.mobileLink} > {t('ent_o_footer_contact_corporate', 'Corporate Services')}: corporate.hk@keetainc.com </div>
        </div>
        <div className={styles.qrcodeWrapper}>
          <div className={styles.pcDownload}>
            <QRCodeCanvas value={DOWNLOAD_LINK}  style={{ width: '10rem', height: '10rem', borderRadius: '10px' }}/>
            <div style={{ paddingTop: '1rem' }} className={styles.qrcodeText}>
              {t('ent_o_nav_download_app', '下载APP')}
            </div>
          </div>
          <a className={styles.mobileDownload} href={DOWNLOAD_LINK}> {t('ent_o_nav_download_app', '下载APP')}</a>
        </div>
      </div>
    </Container>
  )
}

export default Footer